import script from "./IButton.vue?vue&type=script&setup=true&lang=js"
export * from "./IButton.vue?vue&type=script&setup=true&lang=js"

import "./IButton.vue?vue&type=style&index=0&id=322686b4&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-322686b4"]])

export default __exports__